import { actions } from 'react-redux-form';
import { httpGet } from "../../../../../utils/api.utils";

import {
    getCircuitEquipList,
    deleteCircuitEquipItem,
    addCircuitEquipItem,
    updateCircuitEquipItem,
    resetCircuitEquipDetails,
    circuitEquipFormModel,
    onServiceModelSelect
} from "../../../../../constants/model-reducers/external/reports/inventory/details-view/add-equipment.settings";

import { compareIgnoreCase } from "../../../../../utils/helpers.utils";
export const circuitEquipFormInitialState = circuitEquipFormModel;

const defaultState = () => ({
    circuitEquipList: {
        datatable: []
    },
    equipTypes: [],
    equipModels: [],
    equipDevices: [],
    equipAccessories: [],
    equipStatuses: []
});

const initialState = defaultState();

export const inventoryCircuitEquipActions = {
    getCircuitEquipList: (circuitId, vendorId = 0) => async (dispatch, state) => {
        var data = await httpGet('external/inventory/getCircuitEquipList/' + circuitId + "/" + vendorId);

        dispatch({
            type: getCircuitEquipList,
            datatable: data.datatable,
            equipTypes: data.equipTypes,
            equipModels: data.equipModels,
            equipDevices: data.equipDevices,
            equipAccessories: data.equipAccessories,
            equipStatuses: data.equipStatuses
        });
    },

    onServiceModelSelect: (model, value) => async (dispatch, state) => {
        if (value === undefined) {
            dispatch(actions.reset(model));
            dispatch(actions.reset("inventoryCircuitEquipForm.ProductName"));
            dispatch(actions.reset("inventoryCircuitEquipForm.Price"));
        }
        else {
            var data = await httpGet('external/inventory/getCircuitEquipModelList/' + value);
            dispatch(actions.change(model, data.dataModel[0].EquipmentId));
            dispatch(actions.change("inventoryCircuitEquipForm.ProductName", data.dataModel[0].ProductName));
            dispatch(actions.change("inventoryCircuitEquipForm.Price", data.dataModel[0].Price));
        }
    },

    deleteCircuitEquipItem: (index) => (dispatch, state) => {
        const { datatable } = state().inventoryCircuitEquip.circuitEquipList;

        var dataItem = datatable[0].dataItem;
        var HeaderItem = datatable[0].HeaderItem;

        var newDataItem = [...dataItem];
        newDataItem.splice(index, 1);

        var newDataTable = [{
            dataItem: newDataItem,
            HeaderItem: HeaderItem,
        }];

        dispatch({
            type: deleteCircuitEquipItem,
            datatable: newDataTable
        });
    },
    addCircuitEquipItem: () => (dispatch, state) => {
        const { equipTypes, equipModels, equipStatuses } = state().inventoryCircuitEquip;
        const { datatable } = state().inventoryCircuitEquip.circuitEquipList;
        const { inventoryCircuitEquipForm } = state().form;

        var dataItem = datatable[0].dataItem;
        var HeaderItem = datatable[0].HeaderItem;

        var EquipTypeValue = equipTypes.filter(r => parseInt(r.FilterValue) === parseInt(inventoryCircuitEquipForm.TypeId));
        var EquipModelValue = equipModels.filter(r => parseInt(r.FilterValue) === parseInt(inventoryCircuitEquipForm.ModelId));
        var EquipStatusValue = equipStatuses.filter(r => parseInt(r.FilterValue) === parseInt(inventoryCircuitEquipForm.StatusId));

        var newDataItem = [
            ...dataItem,
            {
                ...inventoryCircuitEquipForm,
                ID: -1,
                Type: EquipTypeValue.length > 0 ? EquipTypeValue[0].FilterName : null,
                Model: EquipModelValue.length > 0 ? EquipModelValue[0].FilterName : null,
                Status: EquipStatusValue.length > 0 ? EquipStatusValue[0].FilterName : null,
                Price: inventoryCircuitEquipForm.Price ? parseFloat(inventoryCircuitEquipForm.Price) : 0.00
            }
        ].sort((a, b) => compareIgnoreCase(a.Status, b.Status));

        var newDataTable = [{
            dataItem: newDataItem,
            HeaderItem: HeaderItem,
        }];

        dispatch({
            type: addCircuitEquipItem,
            datatable: newDataTable
        });
    },
    updateCircuitEquipItem: () => (dispatch, state) => {
        const { equipTypes, equipModels, equipStatuses } = state().inventoryCircuitEquip;
        const { datatable } = state().inventoryCircuitEquip.circuitEquipList;
        const { inventoryCircuitEquipForm } = state().form;

        var dataItem = datatable[0].dataItem;
        var HeaderItem = datatable[0].HeaderItem;

        var indexItem = inventoryCircuitEquipForm.ID;
        var EquipTypeValue = equipTypes.filter(r => parseInt(r.FilterValue) === parseInt(inventoryCircuitEquipForm.TypeId));
        var EquipModelValue = equipModels.filter(r => parseInt(r.FilterValue) === parseInt(inventoryCircuitEquipForm.ModelId));
        var EquipStatusValue = equipStatuses.filter(r => parseInt(r.FilterValue) === parseInt(inventoryCircuitEquipForm.StatusId));

        dataItem[indexItem] = {
            ...inventoryCircuitEquipForm,
            ID: dataItem[indexItem].ID,
            Type: EquipTypeValue.length > 0 ? EquipTypeValue[0].FilterName : null,
            Model: EquipModelValue.length > 0 ? EquipModelValue[0].FilterName : null,
            Status: EquipStatusValue.length > 0 ? EquipStatusValue[0].FilterName : null,
            Price: inventoryCircuitEquipForm.Price ? parseFloat(inventoryCircuitEquipForm.Price) : 0.00
        };

        var newDataTable = [{
            dataItem: dataItem,
            HeaderItem: HeaderItem,
        }];

        dispatch({
            type: updateCircuitEquipItem,
            datatable: newDataTable
        });
    },
    viewCircuitEquipItem: (index) => (dispatch, state) => {
        const { datatable } = state().inventoryCircuitEquip.circuitEquipList;

        var dataItem = datatable[0].dataItem[index];

        dataItem = {
            ...dataItem,
            ID: index
        };

        dispatch(actions.reset("inventoryCircuitEquipForm"));
        dispatch(actions.change("inventoryCircuitEquipForm", dataItem));

    },
    resetCircuitEquipForm: () => (dispatch, state) => {
        const formData = {
            ...circuitEquipFormModel,
        };

        dispatch(actions.change("inventoryCircuitEquipForm", formData));
    },
    resetCircuitEquipDetails: () => (dispatch, state) => {
        dispatch({
            type: resetCircuitEquipDetails,
            circuitEquipList: {
                datatable: []
            },
            equipTypes: [],
            equipModels: [],
            equipDevices: [],
            equipAccessories: [],
            equipStatuses: []
        })
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getCircuitEquipList:
            return {
                ...state,
                circuitEquipList: {
                    ...state.circuitEquipList,
                    datatable: action.datatable
                },
                equipTypes: action.equipTypes,
                equipModels: action.equipModels,
                equipDevices: action.equipDevices,
                equipAccessories: action.equipAccessories,
                equipStatuses: action.equipStatuses
            };
        case addCircuitEquipItem:
            return {
                ...state,
                circuitEquipList: {
                    ...state.circuitEquipList,
                    datatable: action.datatable
                }
            };
        case updateCircuitEquipItem:
            return {
                ...state,
                circuitEquipList: {
                    ...state.circuitEquipList,
                    datatable: action.datatable
                }
            };
        case deleteCircuitEquipItem:
            return {
                ...state,
                circuitEquipList: {
                    ...state.circuitEquipList,
                    datatable: action.datatable
                }
            };
        case onServiceModelSelect:
            return {
                ...state,
                circuitEquipList: {
                    ...state.circuitEquipList,
                    datatable: action.datatable
                }
            };
        case resetCircuitEquipDetails:
            return {
                ...state,
                circuitEquipList: action.circuitEquipList,
                equipTypes: action.equipTypes,
                equipModels: action.equipModels,
                equipDevices: action.equipDevices,
                equipAccessories: action.equipAccessories,
                equipStatuses: action.equipStatuses
            };
        default:
            return state;
    }
}